var stars;
var ctx;
var height = 100;

function init() {
    //获取canvas
    stars = document.getElementById("stars");
    //获取当前窗口的宽度和高度
    stars.width = window.innerWidth;//窗口宽度
    stars.height = window.innerHeight;//窗口高度
}

function draw(x, y) {
    ctx = stars.getContext("2d");//返回画布环境2d画面效果
    ctx.beginPath(); //新建一条path
    ctx.moveTo(x, y); //把画笔移动到指定的坐标
    ctx.lineTo(x, y + height);  //绘制一条从当前位置到指定坐标(200, 50)的直线.
    ctx.width = 2;
    // 圆角
    ctx.lineCap = 'round';
    // 透明渐变色
    var gnt1 = ctx.createLinearGradient(x, y, x, y + height);
    gnt1.addColorStop(0.5, 'rgba(10,211,226,0.5)');
    gnt1.addColorStop(0, 'rgba(10,211,226, 0)');
    gnt1.addColorStop(1, 'rgba(10,211,226, 1)');
    ctx.strokeStyle = gnt1;
    //ctx.closePath();
    ctx.stroke(); //绘制路径。

    // 清楚上面的流星
    ctx.clearRect(x - 2, y - 1 - height, 5, height + 2);

    if (y < stars.height) {
        setTimeout(() => { draw(x, y + height) }, 100);
    } else {
        // 清除当前流星
        ctx.clearRect(x - 2, y - 1, 5, height + 2);
    }
}


export function startRains() {
    init();
    for (var i = 0; i < 7; i++) {
        var x = Math.random() * (stars.width + 1);
        var y = Math.random() * (stars.height / 3 + 1);
        draw(x, y);
    }
}